var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-icon rounded-circle p-3",
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    "data-cy": "details"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionDetailBidder(_vm.bidder)
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
                1
              )
            ],
            1
          ),
          _vm._t(
            "action-list",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Desplegar acciones",
                      expression: "'Desplegar acciones'"
                    }
                  ]
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED212",
                          expression: "'ED212'"
                        }
                      ],
                      attrs: { variant: "link", "no-caret": "", right: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  width: "24px",
                                  height: "24px",
                                  "data-cy": "gear-button",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "*" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "binnacle-bidder" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionBinnacleBidder(_vm.bidder)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "person" } }),
                              _vm._v(" Bitácora ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED213" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "edit-bidder" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionEditBidder(_vm.bidder)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "person" } }),
                              _vm._v(" Editar adjudicatario ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED213" } },
                        [
                          _vm.bidder.estadoActivo ===
                          _vm.biddersStateCode.activo
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "deactivate-bidder" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionDeactivateBidder(
                                        _vm.bidder
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "remove_circle" }
                                  }),
                                  _vm._v(" Deshabilitar adjudicatario ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("span")
                ],
                1
              )
            ],
            { receipt: _vm.bidder }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "bidder-detail-" + _vm.bidder.adjudicatarioId,
          attrs: {
            id: "bidder-detail-" + _vm.bidder.adjudicatarioId,
            title: "Detalles",
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [_c("DetailBidder", { attrs: { bidder: _vm.bidder } })],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "edit-bidder-" + _vm.bidder.adjudicatarioId,
          attrs: {
            title: "Editar adjudicatario",
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("BidderForm", {
            attrs: { "actual-bidder": _vm.bidder },
            on: {
              "bidder-save": function($event) {
                return _vm.handleBidderSave()
              }
            }
          })
        ],
        1
      ),
      _c("ModalBinnacle", {
        ref: "binnacle-" + _vm.bidder.adjudicatarioId,
        attrs: {
          title: "Bitácora del adjudicatario " + _vm.bidder.nombre,
          id: "binnacle-" + _vm.bidder.adjudicatarioId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }